
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Header script loaded');
    
    // Mega Menu Elements
    const shopTrigger = document.querySelector('.js-shop-trigger');
    const megaMenu = document.querySelector('[data-menu="shop"]');
    const megaMenuOverlay = document.querySelector('.mega-menu-overlay');
    const tabButtons = document.querySelectorAll('.mega-menu__tab-button');
    
    console.log('Shop trigger exists:', !!shopTrigger);
    console.log('Mega menu exists:', !!megaMenu);
    console.log('Mega menu overlay exists:', !!megaMenuOverlay);
    
    // Mobile Menu Elements
    const hamburgerMenu = document.querySelector('.js-mobile-menu-toggle');
    const mobileMenu = document.querySelector('.js-mobile-menu');
    const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
    
    // Initialize mega menu
    if (shopTrigger && megaMenu && megaMenuOverlay) {
      console.log('Mega menu elements found, attaching event listeners');
      
      // Open/close mega menu
      shopTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Shop trigger clicked');
        
        const isActive = megaMenu.classList.contains('is-active');
        
        if (isActive) {
          closeMegaMenu();
        } else {
          openMegaMenu();
        }
      });
      
      // Close mega menu when clicking overlay
      megaMenuOverlay.addEventListener('click', closeMegaMenu);
      
      // Close mega menu with ESC key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && megaMenu.classList.contains('is-active')) {
          closeMegaMenu();
        }
      });
      
      // Tab navigation
      tabButtons.forEach(button => {
        button.addEventListener('click', function() {
          const category = this.getAttribute('data-category');
          console.log('Tab clicked:', category);
          
          // Update active tab
          tabButtons.forEach(btn => btn.classList.remove('is-active'));
          this.classList.add('is-active');
          
          // Show corresponding content
          const wrappers = document.querySelectorAll('.mega-menu__wrapper');
          wrappers.forEach(wrapper => {
            if (wrapper.getAttribute('data-category') === category) {
              wrapper.style.display = 'block';
            } else {
              wrapper.style.display = 'none';
            }
          });
        });
      });
      
      // Initialize aria-expanded state
      shopTrigger.setAttribute('aria-expanded', 'false');
      
      // Update mega menu position on window resize
      window.addEventListener('resize', updateMegaMenuPosition);
      
      // Initial position update
      updateMegaMenuPosition();
    } else {
      console.error('Mega menu elements not found:', { 
        shopTrigger: !!shopTrigger, 
        megaMenu: !!megaMenu, 
        megaMenuOverlay: !!megaMenuOverlay 
      });
    }

    // Learn dropdown
    const learnTrigger = document.querySelector('.js-learn-trigger');
    const learnDropdown = document.querySelector('[data-menu="learn"]');
    function openLearnDropdown() {
      if (megaMenu && megaMenuOverlay && megaMenu.classList.contains('is-active')) {
        megaMenu.classList.remove('is-active');
        megaMenuOverlay.classList.remove('is-active');
        if (shopTrigger) shopTrigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('mega-menu-open');
      }
      if (learnDropdown) {
        learnDropdown.classList.add('is-active');
        learnDropdown.setAttribute('aria-hidden', 'false');
      }
      if (learnTrigger) learnTrigger.setAttribute('aria-expanded', 'true');
    }
    function closeLearnDropdown() {
      if (learnDropdown) {
        learnDropdown.classList.remove('is-active');
        learnDropdown.setAttribute('aria-hidden', 'true');
      }
      if (learnTrigger) learnTrigger.setAttribute('aria-expanded', 'false');
    }
    if (learnTrigger && learnDropdown) {
      learnTrigger.addEventListener('click', function(e) {
        e.preventDefault();
        if (learnDropdown.classList.contains('is-active')) {
          closeLearnDropdown();
        } else {
          openLearnDropdown();
        }
      });
      document.addEventListener('click', function(e) {
        if (learnDropdown.classList.contains('is-active') &&
            !learnDropdown.contains(e.target) && !learnTrigger.contains(e.target)) {
          closeLearnDropdown();
        }
      });
    }
    
    // Initialize mobile menu
    if (hamburgerMenu && mobileMenu && mobileMenuOverlay) {
      // Toggle mobile menu
      hamburgerMenu.addEventListener('click', function(e) {
        e.preventDefault();
        
        const isActive = mobileMenu.classList.contains('is-active');
        
        if (isActive) {
          closeMobileMenu();
        } else {
          openMobileMenu();
        }
      });
      
      // Close mobile menu when clicking overlay
      mobileMenuOverlay.addEventListener('click', closeMobileMenu);
      
      // Close mobile menu with ESC key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu.classList.contains('is-active')) {
          closeMobileMenu();
        }
      });
      
      // Initialize aria-expanded state
      hamburgerMenu.setAttribute('aria-expanded', 'false');
    }
    
    // Mobile menu is now static HTML using <details>/<summary> - no JS needed
    // initMobileMenu() is no longer called
    
    // Initialize search functionality
    initSearch();
    
    // Helper Functions
    function openMegaMenu() {
      console.log('Opening mega menu');
      closeLearnDropdown();
      megaMenu.classList.add('is-active');
      megaMenuOverlay.classList.add('is-active');
      shopTrigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mega-menu-open');
      
      // Make sure the first tab is selected and displayed
      const firstTab = document.querySelector('.mega-menu__tab-button');
      if (firstTab) {
        firstTab.classList.add('is-active');
        const category = firstTab.getAttribute('data-category');
        
        // Show corresponding content
        const wrappers = document.querySelectorAll('.mega-menu__wrapper');
        wrappers.forEach(wrapper => {
          if (wrapper.getAttribute('data-category') === category) {
            wrapper.style.display = 'block';
          } else {
            wrapper.style.display = 'none';
          }
        });
      }
      
      // Set mega menu to proper height without extra space
      setTimeout(() => {
        // Force proper overflow
        megaMenu.style.overflowY = 'visible';
        
        // Ensure no excessive height is applied
        megaMenu.style.maxHeight = 'none';
        megaMenu.style.minHeight = '0';
        megaMenu.style.paddingBottom = '0';
        
        // Also fix any premium sections
        const premiumSection = document.querySelector('.premium-selections');
        if (premiumSection) {
          premiumSection.style.marginBottom = '0';
          premiumSection.style.paddingBottom = '0';
        }
      }, 300);
    }
    
    function closeMegaMenu() {
      console.log('Closing mega menu');
      megaMenu.classList.remove('is-active');
      megaMenuOverlay.classList.remove('is-active');
      shopTrigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mega-menu-open');
    }
    
    function updateMegaMenuPosition() {
      const headerHeight = document.querySelector('.site-header').offsetHeight;
      megaMenu.style.top = headerHeight + 'px';
      megaMenuOverlay.style.top = headerHeight + 'px';
    }
    
    function openMobileMenu() {
      mobileMenu.classList.add('is-active');
      mobileMenuOverlay.classList.add('is-active');
      hamburgerMenu.classList.add('is-active');
      hamburgerMenu.setAttribute('aria-expanded', 'true');
      document.body.classList.add('body-lock');
    }
    
    function closeMobileMenu() {
      mobileMenu.classList.remove('is-active');
      mobileMenuOverlay.classList.remove('is-active');
      hamburgerMenu.classList.remove('is-active');
      hamburgerMenu.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('body-lock');
      
      // Reset any open submenus
      document.querySelectorAll('.mobile-menu__submenu.is-active').forEach(submenu => {
        submenu.classList.remove('is-active');
      });
    }
    
    function initMobileMenu() {
      try {
        console.log('>>> initMobileMenu START <<<');
        const mobileContent = document.querySelector('.mobile-menu__content');
        
        if (!mobileContent) {
          console.log('>>> mobileContent NOT FOUND <<<');
          return;
        }
        console.log('>>> mobileContent FOUND <<<');
      
      // Full category data matching desktop mega menu
      const categoryData = {
        spices: {
          title: 'SPICES',
          shopAllUrl: '/collections/spices',
          sections: [
            {
              title: 'Essential Spices',
              links: [
                { text: 'Black Pepper', url: '/collections/premium-black-peppercorns-whole-spices', popular: true },
                { text: 'Cinnamon', url: '/collections/cinnamon' },
                { text: 'Turmeric', url: '/collections/premium-turmeric-root-powder', popular: true },
                { text: 'Cardamom', url: '/collections/premium-green-cardamom-pods' },
                { text: 'Cumin', url: '/collections/premium-cumin-seeds-whole' },
                { text: 'Coriander', url: '/collections/premium-coriander-seeds-whole' }
              ],
              shopAll: { text: 'Shop All Spices', url: '/collections/spices' }
            },
            {
              title: 'Global Blends',
              links: [
                { text: 'Garam Masala', url: '/collections/authentic-garam-masala-indian-spice-blend', popular: true },
                { text: 'Curry Powder', url: '/collections/authentic-curry-powder-indian-spice-blend' },
                { text: "Za'atar", url: '/collections/authentic-zaatar-middle-eastern-herb-blend' },
                { text: 'Thai Curry', url: '/collections/authentic-thai-curry-spice-blend' },
                { text: 'Tandoori Masala', url: '/collections/authentic-tandoori-masala-indian-spice-blend' },
                { text: 'Berbere', url: '/collections/authentic-ethiopian-berbere-spice-blend' }
              ],
              shopAll: { text: 'Shop All Global Blends', url: '/collections/global-blends' }
            },
            {
              title: 'Specialty Salts',
              links: [
                { text: 'Black Salt', url: '/collections/indian-black-salt-kala-namak' },
                { text: 'Pink Himalayan', url: '/collections/pink-himalayan-salt-pure-mineral-rich', popular: true },
                { text: 'Celtic Sea Salt', url: '/collections/celtic-sea-salt-grey-sel-gris' },
                { text: 'Smoked Salt', url: '/collections/gourmet-smoked-sea-salt' }
              ],
              shopAll: { text: 'Shop All Specialty Salts', url: '/collections/specialty-salts' }
            }
          ]
        },
        brew: {
          title: 'BREW',
          shopAllUrl: '/collections/brew',
          sections: [
            {
              title: 'Loose Tea',
              links: [
                { text: 'Black Tea', url: '/collections/teas-loose-black-tea', popular: true },
                { text: 'Green Tea', url: '/collections/teas-loose-green-tea', popular: true },
                { text: 'Oolong Tea', url: '/collections/teas-loose-oolong-tea' },
                { text: 'White Tea', url: '/collections/teas-loose-white-tea' },
                { text: 'Pu-erh Tea', url: '/collections/teas-loose-puerh-tea' }
              ],
              shopAll: { text: 'Shop All Loose Tea', url: '/collections/loose-tea' }
            },
            {
              title: 'Herbal Tea',
              links: [
                { text: 'Chamomile', url: '/collections/teas-herbal-chamomile-tea', popular: true },
                { text: 'Peppermint', url: '/collections/teas-herbal-peppermint-tea' },
                { text: 'Rooibos', url: '/collections/teas-herbal-rooibos-tea' },
                { text: 'Hibiscus', url: '/collections/teas-herbal-hibiscus-tea' },
                { text: 'Sleep & Relaxation', url: '/collections/sleep-and-relaxation' }
              ],
              shopAll: { text: 'Shop All Herbal Tea', url: '/collections/herbal-tea' }
            },
            {
              title: 'Tea Tools',
              links: [
                { text: 'Tea Strainers', url: '/collections/tea-tools', popular: true },
                { text: 'Tea Infusers', url: '/collections/tea-tools' },
                { text: 'Empty Tea Bags', url: '/collections/tea-tools' }
              ],
              shopAll: { text: 'Shop All Tea Tools', url: '/collections/tea-tools' }
            }
          ]
        },
        wellness: {
          title: 'WELLNESS',
          shopAllUrl: '/collections/wellness',
          sections: [
            {
              title: 'Herbal Wellness',
              links: [
                { text: 'Adaptogens', url: '/collections/adaptogens' },
                { text: 'Energy & Focus', url: '/collections/energy-and-focus' },
                { text: 'Sleep & Relaxation', url: '/collections/sleep-and-relaxation', popular: true },
                { text: 'Digestive Health', url: '/collections/digestive-health' },
                { text: 'Stress Support', url: '/collections/stress-support' }
              ],
              shopAll: { text: 'Shop All Herbal Wellness', url: '/collections/herbal-wellness' }
            },
            {
              title: 'Superfood Powders',
              links: [
                { text: 'Mushroom Powders', url: '/collections/mushroom-powders', popular: true },
                { text: 'Berry Powders', url: '/collections/berry-powders' },
                { text: 'Green Blends', url: '/collections/green-blends' },
                { text: 'Protein Blends', url: '/collections/protein-blends' }
              ],
              shopAll: { text: 'Shop All Superfood Powders', url: '/collections/superfood-powders' }
            },
            {
              title: 'Sea Moss',
              links: [
                { text: 'Gold Sea Moss', url: '/collections/gold-sea-moss', popular: true },
                { text: 'Purple Sea Moss', url: '/collections/purple-sea-moss' },
                { text: 'Sea Moss Gel', url: '/collections/sea-moss-gel' },
                { text: 'Sea Moss Capsules', url: '/collections/sea-moss-capsules' }
              ],
              shopAll: { text: 'Shop All Sea Moss', url: '/collections/sea-moss' }
            },
            {
              title: 'Supplements',
              links: [
                { text: 'Ayurvedic Herbs', url: '/collections/ayurvedic' },
                { text: 'Capsules', url: '/collections/capsules', popular: true },
                { text: 'Tinctures', url: '/collections/tinctures' },
                { text: 'Extracts', url: '/collections/extracts' }
              ],
              shopAll: { text: 'Shop All Supplements', url: '/collections/supplements' }
            }
          ]
        },
        oils: {
          title: 'OILS',
          shopAllUrl: '/collections/oils',
          sections: [
            {
              title: 'Essential Oils',
              links: [
                { text: 'Lavender', url: '/collections/all-essential-oils' },
                { text: 'Tea Tree', url: '/collections/all-essential-oils' },
                { text: 'Peppermint', url: '/collections/all-essential-oils' },
                { text: 'Eucalyptus', url: '/collections/all-essential-oils' },
                { text: 'Lemon', url: '/collections/all-essential-oils' }
              ],
              shopAll: { text: 'Shop All Essential Oils', url: '/collections/all-essential-oils' }
            },
            {
              title: 'Carrier Oils',
              links: [
                { text: 'Coconut Oil', url: '/collections/oils' },
                { text: 'Jojoba Oil', url: '/collections/oils' },
                { text: 'Argan Oil', url: '/collections/oils' },
                { text: 'Sweet Almond', url: '/collections/oils' }
              ],
              shopAll: { text: 'Shop All Carrier Oils', url: '/collections/oils' }
            },
            {
              title: 'Oil Blends',
              links: [
                { text: 'Sleep & Relaxation', url: '/collections/essential-oil-blends' },
                { text: 'Immunity Support', url: '/collections/essential-oil-blends' },
                { text: 'Focus & Clarity', url: '/collections/essential-oil-blends' },
                { text: 'Stress Relief', url: '/collections/essential-oil-blends' }
              ],
              shopAll: { text: 'Shop All Oil Blends', url: '/collections/essential-oil-blends' }
            }
          ]
        },
        pantry: {
          title: 'PANTRY',
          shopAllUrl: '/collections/pantry',
          sections: [],
          comingSoon: true
        },
        sacred: {
          title: 'SACRED',
          shopAllUrl: '/collections/sacred',
          sections: [],
          comingSoon: true
        }
      };
      
      // Create main mobile menu links
      const mainLinks = [
        { text: 'SHOP', hasSubmenu: true },
        { text: 'CONNECT', url: '/pages/connect' },
        { text: 'LEARN', url: '/pages/learn' },
        { text: 'ACCOUNT', url: '/account' },
        { text: 'CART', url: '/cart' }
      ];
      
      // Clear existing content
      mobileContent.innerHTML = '';
      
      // Create main menu
      const mainMenu = document.createElement('nav');
      mainMenu.className = 'mobile-menu__nav';
      
      mainLinks.forEach(link => {
        const linkElement = document.createElement(link.hasSubmenu ? 'button' : 'a');
        linkElement.className = 'mobile-menu__link';
        
        if (link.hasSubmenu) {
          linkElement.setAttribute('type', 'button');
          linkElement.classList.add('mobile-menu__link--has-submenu');
          linkElement.setAttribute('role', 'button');
          linkElement.innerHTML = `
            ${link.text}
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M4 2L8 6L4 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
          
          // Create submenu for SHOP
          if (link.text === 'SHOP') {
            const shopSubmenu = document.createElement('div');
            shopSubmenu.className = 'mobile-menu__submenu';
            shopSubmenu.id = 'shop-submenu';
            
            // Add back button
            const backBtn = document.createElement('button');
            backBtn.className = 'mobile-menu__back';
            backBtn.innerHTML = `
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M8 10L4 6L8 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Back to Menu
            `;
            shopSubmenu.appendChild(backBtn);
            
            // Add shop categories with nested submenus
            Object.keys(categoryData).forEach(categoryKey => {
              const category = categoryData[categoryKey];
              
              // Create category button/link
              const categoryBtn = document.createElement('button');
              categoryBtn.className = 'mobile-menu__link mobile-menu__link--has-submenu';
              categoryBtn.innerHTML = `
                ${category.title}
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M4 2L8 6L4 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              `;
              shopSubmenu.appendChild(categoryBtn);
              
              // Create nested submenu for this category
              const categorySubmenu = document.createElement('div');
              categorySubmenu.className = 'mobile-menu__submenu';
              categorySubmenu.id = `${categoryKey}-submenu`;
              
              // Add back button for category submenu
              const categoryBackBtn = document.createElement('button');
              categoryBackBtn.className = 'mobile-menu__back';
              categoryBackBtn.innerHTML = `
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M8 10L4 6L8 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Back to Shop
              `;
              categorySubmenu.appendChild(categoryBackBtn);
              
              // Add "Shop All [Category]" at the top
              const shopAllTop = document.createElement('a');
              shopAllTop.className = 'mobile-menu__shop-all';
              shopAllTop.href = category.shopAllUrl;
              shopAllTop.textContent = `Shop All ${category.title} →`;
              categorySubmenu.appendChild(shopAllTop);
              
              if (category.comingSoon) {
                // Coming soon message
                const comingSoon = document.createElement('div');
                comingSoon.style.cssText = 'padding: 40px 20px; text-align: center; color: #666;';
                comingSoon.innerHTML = `
                  <p style="font-size: 16px; font-weight: 500; margin-bottom: 8px;">Coming Soon</p>
                  <p style="font-size: 14px;">We're expanding our ${category.title.toLowerCase()} selection.</p>
                `;
                categorySubmenu.appendChild(comingSoon);
              } else {
                // Add sections with links
                category.sections.forEach(section => {
                  const sectionHeader = document.createElement('div');
                  sectionHeader.className = 'mobile-menu__category-header';
                  sectionHeader.textContent = section.title;
                  categorySubmenu.appendChild(sectionHeader);
                  
                  section.links.forEach(linkData => {
                    const sublink = document.createElement('a');
                    sublink.className = 'mobile-menu__sublink';
                    if (linkData.popular) {
                      sublink.classList.add('mobile-menu__sublink--popular');
                    }
                    sublink.href = linkData.url;
                    sublink.textContent = linkData.text;
                    categorySubmenu.appendChild(sublink);
                  });
                  
                  // Add section shop all link
                  if (section.shopAll) {
                    const sectionShopAll = document.createElement('a');
                    sectionShopAll.className = 'mobile-menu__sublink';
                    sectionShopAll.href = section.shopAll.url;
                    sectionShopAll.style.fontWeight = '600';
                    sectionShopAll.style.color = '#1B4332';
                    sectionShopAll.textContent = section.shopAll.text + ' →';
                    categorySubmenu.appendChild(sectionShopAll);
                  }
                });
              }
              
              // Add category submenu to mobile content
              mobileContent.appendChild(categorySubmenu);
              
              // Add data attributes for event delegation (plus inline fallbacks)
              categoryBtn.setAttribute('type', 'button');
              categoryBtn.setAttribute('data-action', 'open-category-submenu');
              categoryBtn.setAttribute('data-category', categoryKey);
              categoryBtn.setAttribute('onclick', `document.getElementById('${categoryKey}-submenu')?.classList.add('is-active');`);
              
              categoryBackBtn.setAttribute('type', 'button');
              categoryBackBtn.setAttribute('data-action', 'close-category-submenu');
              categoryBackBtn.setAttribute('data-category', categoryKey);
              categoryBackBtn.setAttribute('onclick', `document.getElementById('${categoryKey}-submenu')?.classList.remove('is-active');`);
            });
            
            // Add "Shop All" link at the bottom
            const shopAllLink = document.createElement('a');
            shopAllLink.className = 'mobile-menu__link';
            shopAllLink.href = '/collections/all';
            shopAllLink.textContent = 'SHOP ALL PRODUCTS';
            shopAllLink.style.marginTop = '16px';
            shopAllLink.style.color = '#1B4332';
            shopAllLink.style.fontWeight = '600';
            shopSubmenu.appendChild(shopAllLink);
            
            // Add submenu to document
            mobileContent.appendChild(shopSubmenu);
            
            // Add data attributes for event delegation (plus inline fallbacks)
            linkElement.setAttribute('data-action', 'open-shop-submenu');
            linkElement.setAttribute('onclick', "document.getElementById('shop-submenu')?.classList.add('is-active');");
            backBtn.setAttribute('data-action', 'close-shop-submenu');
            backBtn.setAttribute('onclick', "document.getElementById('shop-submenu')?.classList.remove('is-active');");
            
            console.log('SHOP button created:', linkElement);
          }
        } else {
          linkElement.href = link.url;
          linkElement.textContent = link.text;
        }
        
        mainMenu.appendChild(linkElement);
      });
      
      mobileContent.appendChild(mainMenu);
      
      // EVENT DELEGATION - Single handler for all mobile menu interactions
      // This is more reliable on mobile than individual event listeners
      function handleMobileMenuAction(e) {
        const target = e.target.closest('[data-action]');
        if (!target) return;
        
        const action = target.getAttribute('data-action');
        const category = target.getAttribute('data-category');
        
        console.log('Mobile menu action:', action, category);
        
        e.preventDefault();
        e.stopPropagation();
        
        switch(action) {
          case 'open-shop-submenu':
            const shopSubmenu = document.getElementById('shop-submenu');
            if (shopSubmenu) shopSubmenu.classList.add('is-active');
            break;
            
          case 'close-shop-submenu':
            const shopSubmenuClose = document.getElementById('shop-submenu');
            if (shopSubmenuClose) shopSubmenuClose.classList.remove('is-active');
            break;
            
          case 'open-category-submenu':
            const catSubmenu = document.getElementById(category + '-submenu');
            if (catSubmenu) catSubmenu.classList.add('is-active');
            break;
            
          case 'close-category-submenu':
            const catSubmenuClose = document.getElementById(category + '-submenu');
            if (catSubmenuClose) catSubmenuClose.classList.remove('is-active');
            break;
        }
      }
      
      // Use click, touchstart, and touchend for maximum compatibility
      mobileContent.addEventListener('click', handleMobileMenuAction);
      mobileContent.addEventListener('touchstart', function(e) {
        const target = e.target.closest('[data-action]');
        if (target) {
          // Prevent ghost clicks on mobile
          e.preventDefault();
          handleMobileMenuAction(e);
        }
      }, { passive: false });
      mobileContent.addEventListener('touchend', function(e) {
        const target = e.target.closest('[data-action]');
        if (target) {
          e.preventDefault();
          handleMobileMenuAction(e);
        }
      }, { passive: false });
      
      console.log('>>> initMobileMenu COMPLETED with event delegation <<<');
      } catch (e) {
        console.error('>>> initMobileMenu ERROR:', e);
      }
    }
    
    function initSearch() {
      // Doofinder 2.x auto-binds to <input type="search"> elements on the page.
      // When focused/clicked, Doofinder opens its fullscreen search layer.
      // Our header uses icon buttons, so we focus the hidden search input to trigger it.
      
      var dfTrigger = document.getElementById('df-search-trigger');
      var searchButtons = document.querySelectorAll('.js-search-toggle');
      
      searchButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          if (dfTrigger) {
            // Briefly make the input focusable
            dfTrigger.style.opacity = '1';
            dfTrigger.style.pointerEvents = 'auto';
            dfTrigger.parentElement.style.zIndex = '99999';
            dfTrigger.parentElement.style.opacity = '1';
            dfTrigger.parentElement.style.pointerEvents = 'auto';
            dfTrigger.parentElement.style.height = 'auto';
            dfTrigger.parentElement.style.overflow = 'visible';
            dfTrigger.focus();
            dfTrigger.click();
            
            // Re-hide after Doofinder picks it up
            setTimeout(function() {
              dfTrigger.parentElement.style.zIndex = '-1';
              dfTrigger.parentElement.style.opacity = '0';
              dfTrigger.parentElement.style.pointerEvents = 'none';
              dfTrigger.parentElement.style.height = '0';
              dfTrigger.parentElement.style.overflow = 'hidden';
            }, 300);
          }
        });
      });
      
      console.log('Search init - attached to', searchButtons.length, 'buttons (Doofinder 2.x)');
    }
  });

;

  document.addEventListener('DOMContentLoaded', function() {
    // Combined functionality from all previous scripts
    
    // Fix featured items alignment and text centering
    function fixFeaturedItems() {
      // Featured items wrapper for vertical centering
      const featuredItems = document.querySelectorAll('.mega-menu__featured-item a');
      featuredItems.forEach(item => {
        item.style.display = 'block';
        item.style.padding = '10px';
      });
    }
    
    // Set column titles to 20px (15% smaller than requested 24px)
    function adjustColumnTitleSize() {
      const columnTitles = document.querySelectorAll('.mega-menu__column-title');
      columnTitles.forEach(title => {
        title.style.fontSize = '20px';
        title.style.setProperty('font-size', '20px', 'important');
      });
    }
    
    // Fix menu container sizes to match
    function fixMenuContainerSizes() {
      // First, get the brew menu container dimensions
      const brewMenu = document.querySelector('.mega-menu__wrapper[data-category="brew"]');
      const wellnessMenu = document.querySelector('.mega-menu__wrapper[data-category="wellness"]');
      
      if (brewMenu && wellnessMenu) {
        // Force the overall wrappers to have same size/position
        const brewStyles = window.getComputedStyle(brewMenu);
        wellnessMenu.style.width = brewStyles.width;
        wellnessMenu.style.maxWidth = brewStyles.maxWidth;
        wellnessMenu.style.margin = brewStyles.margin;
        wellnessMenu.style.padding = brewStyles.padding;
        wellnessMenu.style.boxSizing = 'border-box';
        wellnessMenu.style.backgroundColor = brewMenu.style.backgroundColor || '#f9f6f1';
        
        // Apply container width fix
        const brewContent = brewMenu.querySelector('.mega-menu__content');
        const wellnessContent = wellnessMenu.querySelector('.mega-menu__content');
        
        if (brewContent && wellnessContent) {
          // Copy ALL computed dimensions from brew to wellness
          const brewContentStyles = window.getComputedStyle(brewContent);
          
          // Force exact same dimensions
          wellnessContent.style.cssText = ''; // Clear existing inline styles
          
          // Force EXACT match for all size properties
          wellnessContent.style.width = brewContentStyles.width;
          wellnessContent.style.maxWidth = brewContentStyles.maxWidth;
          wellnessContent.style.minWidth = brewContentStyles.minWidth;
          wellnessContent.style.margin = brewContentStyles.margin;
          wellnessContent.style.padding = brewContentStyles.padding;
          wellnessContent.style.boxSizing = brewContentStyles.boxSizing;
          
          // Also apply to grid containers
          const brewGrid = brewMenu.querySelector('.mega-menu__grid');
          const wellnessGrid = wellnessMenu.querySelector('.mega-menu__grid');
          
          if (brewGrid && wellnessGrid) {
            const brewGridStyles = window.getComputedStyle(brewGrid);
            
            wellnessGrid.style.width = brewGridStyles.width;
            wellnessGrid.style.maxWidth = brewGridStyles.maxWidth;
            wellnessGrid.style.margin = brewGridStyles.margin;
            wellnessGrid.style.padding = brewGridStyles.padding;
            wellnessGrid.style.display = brewGridStyles.display;
            wellnessGrid.style.gridTemplateColumns = brewGridStyles.gridTemplateColumns;
            wellnessGrid.style.gap = brewGridStyles.gap;
          }
        }
      }
    }
    
    // Execute immediately
    fixFeaturedItems();
    adjustColumnTitleSize();
    fixMenuContainerSizes();
    
    // Execute after delays
    setTimeout(function() {
      fixFeaturedItems();
      adjustColumnTitleSize();
      fixMenuContainerSizes();
    }, 100);
    
    setTimeout(function() {
      fixFeaturedItems();
      adjustColumnTitleSize();
      fixMenuContainerSizes();
    }, 500);
    
    // Handle window resize
    window.addEventListener('resize', function() {
      fixFeaturedItems();
      fixMenuContainerSizes();
    });
    
    // Setup event listeners for tab clicks
    const tabButtons = document.querySelectorAll('.mega-menu-trigger, .mega-menu__tab-button, [data-category-trigger]');
    tabButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        setTimeout(function() {
          fixFeaturedItems();
          adjustColumnTitleSize();
          fixMenuContainerSizes();
        }, 50);
      });
    });
    
    // Mobile menu functionality
    const hamburgerButton = document.getElementById('hamburger-menu-button');
    const mobileMenu = document.querySelector('.mobile-menu');
    const overlay = document.querySelector('.mobile-menu-overlay');
    
    if (hamburgerButton && mobileMenu) {
      hamburgerButton.addEventListener('click', function() {
        hamburgerButton.classList.toggle('is-active');
        mobileMenu.classList.toggle('is-active');
        document.body.classList.toggle('body-lock');
        
        if (overlay) {
          overlay.classList.toggle('is-active');
        }
      });
      
      // Handle mobile menu close
      const closeButton = document.querySelector('.js-mobile-menu-close');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          hamburgerButton.classList.remove('is-active');
          mobileMenu.classList.remove('is-active');
          document.body.classList.remove('body-lock');
          
          if (overlay) {
            overlay.classList.remove('is-active');
          }
        });
      }
      
      // Handle overlay click to close
      if (overlay) {
        overlay.addEventListener('click', function() {
          hamburgerButton.classList.remove('is-active');
          mobileMenu.classList.remove('is-active');
          document.body.classList.remove('body-lock');
          overlay.classList.remove('is-active');
        });
      }
    }
  });
